export default {
  state: {
    data: {
      type: '',
      title: '',
      content: '',
      notes: '',
      expireTime: '',
      password: '',
    }
  },
  mutations: {
    SetShareData(state, data){
      state.data = {
        type: '',
        title: '',
        content: '',
        notes: '',
        expireTime: '',
        password: '',
      }
    }

  },
  actions: {

  },
  getters: {

  }
}
